import type SearchResultFunnelEvent from "@/types/funnel/searchResultFunnelEvent";
import type { ResultItem } from "@/types/resultItem";
import type EcommerceItem from "@/types/ecommerceItem";
import createEcommerceItem from "@/services/ecommerceItemFactory";
import { SCONTENT } from "@/globalConsts/queryParams";
import {
  ITEM_LIST_ID,
  ITEM_LIST_NAME,
} from "@/globalConsts/searchFunnelEvents";

export function createSearchResultFunnelEvent(
  event: string,
  resultItems: ResultItem[],
  index: number
): SearchResultFunnelEvent {
  return {
    event: event,
    ecommerce: {
      item_list_id: ITEM_LIST_ID,
      item_list_name: ITEM_LIST_NAME,
      search_header: new URLSearchParams(location.search).get(SCONTENT) ?? "",
      items: convertResultItemsToEcommerceItems(resultItems, index),
    },
  } as SearchResultFunnelEvent;
}

function convertResultItemsToEcommerceItems(
  resultItems: ResultItem[],
  index: number
): EcommerceItem[] {
  const items: EcommerceItem[] = [];
  for (let i = 0; i < resultItems.length; i++) {
    if (index != -1) {
      items.push(createEcommerceItem(resultItems[i], index));
      continue;
    }
    items.push(createEcommerceItem(resultItems[i], i));
  }
  return items;
}
